module.exports = __webpack_public_path__ + "img/logo-pnnl-bw.10288a50.png";